<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Upload documents</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div class="row">
      <div class="col-6">
        <mat-card appearance="outlined">
          <mat-card-content>
            <div class="row">
              <div class="col-12">
                <mat-form-field appearance="outline">
                  <mat-label>Select document type</mat-label>
                  <mat-select placeholder="Select document type" formControlName="documentType" (selectionChange)="updateSelectedDocType($event.value, formGroup)">
                    <mat-option *ngFor="let docType of allDocTypes" [value]="docType?.id">{{docType?.text}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row" [hidden]="!showSecurities">
              <div class="col-12">
                <mat-form-field appearance="outline">
                  <mat-label>Select the security</mat-label>
                  <mat-select placeholder="Select the security" formControlName="securities" multiple>
                    <mat-option *ngFor="let security of securities" [value]="security?.id">{{security?.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error *ngIf="!formGroup.get('securities').valid">
                  Please select a security from the list
                </mat-error>
              </div>
            </div>
            <div class="row" [hidden]="!showParties">
              <div class="col-12">
                <mat-form-field appearance="outline">
                  <mat-label>Select the applicant</mat-label>
                  <mat-select placeholder="Select the applicant" formControlName="parties" multiple>
                    <mat-option *ngFor="let party of parties" [value]="party?.id">{{party?.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error *ngIf="!formGroup.get('parties').valid">
                  Please select an applicant from the list
                </mat-error>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <mat-form-field appearance="outline">
                  <mat-label>Add comments</mat-label>
                  <input matInput placeholder="Add comments" formControlName="comments">
                </mat-form-field>
              </div>
            </div>
            <div class="row" *ngIf="uploadData.length > 0">
              <div class="col-12">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>Selected documents</mat-label>
                  <mat-chip-grid #chipList>
                    <mat-chip-row *ngFor="let file of uploadData; let i=index" (removed)="deleteTempDoc(i)">
                      {{file.origName}}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip-row>
                    <input matInput placeholder="Selected Documents" [matChipInputFor]="chipList" readonly/>
                  </mat-chip-grid>
                </mat-form-field>
              </div>
            </div>
            <div class="row" *ngIf="showUploader">
              <div class="col-12">
                <div ng2FileDrop
                     [ngClass]="{'drop__zone--has-file-over': hasDropZoneOver}"
                     (fileOver)="fileOverBase($event)"
                     [uploader]="uploader"
                     class="drop__zone">
                  <ng-container *ngIf="loading">
                    <small>Uploading your file... Please wait</small>
                  </ng-container>
                  <ng-container *ngIf="!loading">
                    <small>Add comments and then drag file(s) here or click below. <br/>
                      Please do not forget to click the Upload button afterwards.</small>
                  </ng-container>
                  <hr/>
                  <input type="file" class="upload-file-button" ng2FileSelect [uploader]="uploader" multiple />
                </div>
              </div>
            </div>

            <div class="row" *ngIf="formGroup.errors?.upload">
              <div class="col-12">
                <mat-error>Please confirm the files and click "Upload" or clear the file queue to continue.</mat-error>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <button mat-raised-button type="button" color="primary" (click)="addFileToList(formGroup)" [disabled]="uploadData.length <= 0">Upload</button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="col-6">
        <mat-card>
          <mat-card-content>
            <div class="row">
              <div class="col-12">
                <h4>Uploaded Files</h4>
                <small *ngIf="documentArray && documentArray.value.length === 0; else uploadList">
                  No files uploaded yet. <br/>
                  Please select a document type, select / drag your files into the box provided, and click the "Upload" in order to attach.
                </small>
                <ng-template #uploadList>
                  <table class="table table-striped table-fixed table-hover table-sm mb-0">
                    <thead class="table-header">
                    <tr>
                      <th>Filename</th>
                      <th>Type</th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngIf="documentArray && documentArray.value.length > 0">
                      <tr *ngFor="let file of documentArray.value; let i = index">
                        <td>({{file.description}}) {{file.origName}}
                          <small *ngIf="file.comments"><br/>{{file.comments}}</small>
                        </td>
                        <td>{{file.documentTypeCode}}</td>
                        <td>
                          <button mat-icon-button (click)="deleteDoc(i)" type="button">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </td>
                      </tr>
                    </ng-container>
                    </tbody>
                  </table>
                </ng-template>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </mat-card-content>
</mat-card>
